import { render, staticRenderFns } from "./MusicWiz.vue?vue&type=template&id=3774fce9&"
import script from "./MusicWiz.vue?vue&type=script&lang=js&"
export * from "./MusicWiz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports